(function () {
  "use strict";

  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal, .mt-reveal-scale");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll("[data-mt-countup]");
    if (!els.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          var target = parseFloat(el.getAttribute("data-mt-countup")) || 0;
          var decimals = (el.getAttribute("data-mt-countup").split(".")[1] || "").length;
          var duration = 1400;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = (target * eased).toFixed(decimals);
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = target.toFixed(decimals);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initProducto() {
    var root = document.querySelector("[data-mt-producto]");
    if (!root) return;

    var mainImg = root.querySelector("[data-mt-galeria-principal]");
    var mainImgWrap = root.querySelector("[data-mt-galeria-principal-wrap]");
    var thumbs = root.querySelectorAll("[data-mt-miniatura]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        var alt = thumb.getAttribute("data-alt") || "";
        if (!full || !mainImg) return;
        mainImgWrap.classList.remove("mt-visible");
        window.setTimeout(function () {
          mainImg.src = full;
          mainImg.alt = alt;
          mainImgWrap.classList.add("mt-visible");
        }, 120);
        thumbs.forEach(function (t) { t.classList.remove("mt-miniatura-activa"); });
        thumb.classList.add("mt-miniatura-activa");
      });
    });

    var variantsDataEl = root.querySelector("[data-mt-variantes-json]");
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector("[data-mt-precio]");
    var comparePriceEl = root.querySelector("[data-mt-precio-comparado]");
    var addBtn = root.querySelector("[data-mt-add-btn]");
    var optionSelects = root.querySelectorAll("[data-mt-opcion]");

    if (variantsDataEl && optionSelects.length) {
      var variants = [];
      try { variants = JSON.parse(variantsDataEl.textContent); } catch (e) { variants = []; }

      function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2);
      }

      function findVariant() {
        var selected = [];
        optionSelects.forEach(function (sel) { selected.push(sel.value); });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function updateForVariant() {
        var variant = findVariant();
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = "";
          } else {
            comparePriceEl.style.display = "none";
          }
        }
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute("data-texto-disponible") || addBtn.textContent;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute("data-texto-agotado") || "Agotado";
          }
        }
      }

      optionSelects.forEach(function (sel) { sel.addEventListener("change", updateForVariant); });
    }
  }

  function initAcordeon() {
    document.querySelectorAll("[data-mt-acordeon-item]").forEach(function (item) {
      var trigger = item.querySelector("[data-mt-acordeon-trigger]");
      if (!trigger) return;
      trigger.addEventListener("click", function () {
        var isOpen = item.classList.contains("mt-acordeon-abierto");
        item.closest("[data-mt-acordeon]").querySelectorAll("[data-mt-acordeon-item]").forEach(function (i) {
          i.classList.remove("mt-acordeon-abierto");
        });
        if (!isOpen) item.classList.add("mt-acordeon-abierto");
      });
    });
  }

  function initTiltCards() {
    if (window.matchMedia && window.matchMedia("(hover: none)").matches) return;
    document.querySelectorAll("[data-mt-tilt]").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = "perspective(800px) rotateY(" + (x * 6) + "deg) rotateX(" + (y * -6) + "deg) translateY(-4px)";
      });
      card.addEventListener("mouseleave", function () {
        card.style.transform = "";
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initCountUp();
    initProducto();
    initAcordeon();
    initTiltCards();
  });
})();
